export default __webpack_public_path__ + "static/media/trash.c6f6adc8.svg";